// Contributions retain individual identities even when resource sections are aggregated.
export const filterUnseenRewardAlert = (alert, seen = new Set()) => {
  if (!alert || typeof alert !== 'object') return null;
  const contributions = Array.isArray(alert.rewardContributions)
    ? alert.rewardContributions
    : (alert.rewardId ? [{ ...alert, id: alert.rewardId }] : null);
  if (!contributions) return alert;

  const unique = contributions.filter((item) => {
    if (!item?.id || seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
  if (!unique.length) return null;
  const result = { ...alert, rewardContributions: unique };
  if (alert.type === 'gettoncini') {
    result.amount = unique.reduce((total, item) => total + (Number(item.amount) || 0), 0);
  }
  if (alert.type === 'stelline' || alert.type === 'learned_terms') {
    ['delta', 'actualDelta', 'potentialDelta'].forEach((field) => {
      result[field] = unique.reduce((total, item) => total + (Number(item[field]) || 0), 0);
    });
    result.message = unique[unique.length - 1].message || null;
  }
  return result;
};

export const deduplicateRewardAlerts = (alerts = [], seen = new Set()) => (
  alerts.map((alert) => filterUnseenRewardAlert(alert, seen)).filter(Boolean)
);

export const combineResourceRewardAlerts = (alerts = []) => {
  const combined = [];
  alerts.forEach((alert) => {
    const existing = alert.rewardContributions && ['stelline', 'learned_terms'].includes(alert.type)
      ? combined.find((item) => item.type === alert.type && item.rewardContributions && item.isAnonymous === alert.isAnonymous)
      : null;
    if (!existing) {
      combined.push({ ...alert });
      return;
    }
    ['delta', 'actualDelta', 'potentialDelta'].forEach((field) => {
      existing[field] = (Number(existing[field]) || 0) + (Number(alert[field]) || 0);
    });
    existing.message = alert.message;
    existing.rewardContributions = [...existing.rewardContributions, ...alert.rewardContributions];
  });
  return combined;
};
